import React from 'react';
import cx from 'classnames';
import moment from 'moment-timezone';

import Badge, { SuccessBadge } from '@magoosh/lib/badge';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { PremiumBadge } from '@magoosh/lib/info_badges';

import { MockTestTemplate } from '../../../types';

import LayersIcon from '../assets/layers_icon.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  isRecommended: boolean;
  isSelected?: boolean;
  template: MockTestTemplate;
}

export default (props: Props) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  return (
    <div
      className={cx(
        'align-items-center d-flex flex-1 flex-wrap gap-xs gap-sm-s',
        // If the option is already selected we don't need hover styles
        { [style.templateOption]: !props.isSelected }
      )}
      style={{ padding: '8px 16px' }}
    >
      {
        !props.template.available && (
          <PremiumBadge style={{ fontSize: 12, padding: '4px 8px' }} />
        )
      }

      <div>{props.template.name}{!props.template.explanations && '*'}</div>

      {
        props.template.sharedPool && (
          <div className="small">
            <img alt="" src={LayersIcon} /><span className="hidden-xs"> Shared pool</span>
          </div>
        )
      }

      {
        props.isRecommended && (
          <Badge style={{ background: colors.purpleLight, color: colors.purple }}>
            Recommended
          </Badge>
        )
      }

      {
        !props.template.poolBased && props.template.lastFinishedAt && (
          <SuccessBadge>
            <div className="hidden-xs">
              Last Taken {
                moment(props.template.lastFinishedAt * 1000).tz(timeZone).isSame(moment().tz(timeZone), 'day')
                  ? 'Today'
                  : moment(props.template.lastFinishedAt * 1000).tz(timeZone).fromNow()
              }
            </div>

            <div className="visible-xs">
              <FontAwesomeIcon icon="check" style={{ WebkitTextStroke: '1px #DEF4EB' }} />
            </div>
          </SuccessBadge>
        )
      }
    </div>
  );
};
